import * as React from 'react';
import './ToggleButtons.scss';

export interface IButtons {
  value: any;
  label: string;
}

interface IToggleButtonsProps {
  value: any;
  onValueChange: (value: any) => void;
  buttons: IButtons[];
}

const ToggleButtons: React.FC<IToggleButtonsProps> = ({
  value,
  onValueChange,
  buttons
}) => {
  return (
    <div className="rp-toggle-buttons-container">
      {buttons.map(button => {
        return (
          <button
            key={button.value}
            onClick={() => onValueChange(button.value)}
            className={`rp-toogle-buttons__button ${
              button.value === value
                ? 'rp-toogle-buttons__button--selected'
                : ''
            }`}
          >
            {button.label}
          </button>
        );
      })}
    </div>
  );
};

export default ToggleButtons;
